// ai_setting Redux actions
// Action types
export const SET_AI_SETTING_VISIBLE = 'SET_AI_SETTING_VISIBLE';
export const SET_AI_SETTING_SETTINGS = 'SET_AI_SETTING_SETTINGS';
export const SET_AI_SETTING_CURRENT = 'SET_AI_SETTING_CURRENT';
export const SET_AI_SETTING_LOADING = 'SET_AI_SETTING_LOADING';
export const SET_AI_SETTING_SAVING = 'SET_AI_SETTING_SAVING';
export const SET_AI_SETTING_ERROR = 'SET_AI_SETTING_ERROR';
export const ADD_AI_SETTING = 'ADD_AI_SETTING';
export const UPDATE_AI_SETTING = 'UPDATE_AI_SETTING';
export const REMOVE_AI_SETTING = 'REMOVE_AI_SETTING';
// Action creators
export function setAiSettingVisible(visible) {
    return {
        type: SET_AI_SETTING_VISIBLE,
        visible
    };
}
export function setAiSettingSettings(settings) {
    return {
        type: SET_AI_SETTING_SETTINGS,
        settings
    };
}
export function setAiSettingCurrent(setting) {
    return {
        type: SET_AI_SETTING_CURRENT,
        setting
    };
}
export function setAiSettingLoading(loading) {
    return {
        type: SET_AI_SETTING_LOADING,
        loading
    };
}
export function setAiSettingSaving(saving) {
    return {
        type: SET_AI_SETTING_SAVING,
        saving
    };
}
export function setAiSettingError(error) {
    return {
        type: SET_AI_SETTING_ERROR,
        error
    };
}
export function addAiSetting(setting) {
    return {
        type: ADD_AI_SETTING,
        setting
    };
}
export function updateAiSetting(setting) {
    return {
        type: UPDATE_AI_SETTING,
        setting
    };
}
export function removeAiSetting(id) {
    return {
        type: REMOVE_AI_SETTING,
        id
    };
}
